var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoShareHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 41.5,
    fill: "url(#paint0_linear_1011_19255)",
    stroke: "#424242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.999 57.1875C45.0028 57.1875 47.9392 56.2968 50.4367 54.628C52.9343 52.9591 54.8809 50.5872 56.0304 47.812C57.18 45.0369 57.4807 41.9832 56.8947 39.0371C56.3087 36.091 54.8622 33.3848 52.7382 31.2608C50.6142 29.1368 47.908 27.6903 44.962 27.1043C42.0159 26.5183 38.9622 26.8191 36.187 27.9686C33.4119 29.1181 31.0399 31.0647 29.3711 33.5623C27.7023 36.0599 26.8115 38.9962 26.8115 42C26.8176 46.0261 28.4196 49.8856 31.2665 52.7325C34.1134 55.5794 37.9729 57.1814 41.999 57.1875ZM40.3115 36.9375C40.3115 36.49 40.4893 36.0607 40.8058 35.7443C41.1222 35.4278 41.5515 35.25 41.999 35.25C42.4466 35.25 42.8758 35.4278 43.1923 35.7443C43.5087 36.0607 43.6865 36.49 43.6865 36.9375V41.2913L46.7746 44.3794C47.0903 44.6976 47.267 45.1279 47.266 45.5761C47.2651 46.0243 47.0867 46.4538 46.7698 46.7707C46.4528 47.0877 46.0233 47.2661 45.5751 47.267C45.1269 47.2679 44.6966 47.0913 44.3784 46.7756L40.8009 43.1981C40.4913 42.8756 40.3163 42.4471 40.3115 42V36.9375Z",
    fill: "url(#paint1_linear_1011_19255)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9997 18.375C41.5522 18.375 41.1229 18.5528 40.8065 18.8693C40.49 19.1858 40.3122 19.615 40.3122 20.0625C40.3122 20.5101 40.49 20.9393 40.8065 21.2558C41.1229 21.5722 41.5522 21.75 41.9997 21.75C46.7238 21.7305 51.3072 23.3564 54.9629 26.3485C58.6187 29.3406 61.1186 33.5122 62.0333 38.1468C62.948 42.7815 62.2205 47.5901 59.9757 51.7467C57.7309 55.9034 54.1089 59.1488 49.7317 60.9256C45.3545 62.7023 40.4952 62.8996 35.9884 61.4835C31.4815 60.0675 27.6083 57.1264 25.034 53.1654C22.4596 49.2043 21.3447 44.4706 21.8807 39.777C22.4167 35.0834 24.5702 30.7229 27.9714 27.4443L27.8569 28.3171C27.7988 28.761 27.9193 29.2097 28.192 29.5647C28.4647 29.9197 28.8672 30.1518 29.3111 30.21C29.7549 30.2682 30.2037 30.1476 30.5587 29.8749C30.9136 29.6022 31.1458 29.1997 31.2039 28.7559L31.8607 23.7362C31.9009 23.2956 31.7734 22.856 31.5036 22.5053C31.2339 22.1546 30.8418 21.9186 30.4056 21.8444L25.3859 21.1881C25.1632 21.1527 24.9356 21.1623 24.7166 21.2163C24.4976 21.2704 24.2916 21.3678 24.1109 21.5028C23.9302 21.6378 23.7784 21.8076 23.6645 22.0023C23.5505 22.197 23.4768 22.4125 23.4476 22.6362C23.4184 22.8599 23.4343 23.0871 23.4945 23.3045C23.5546 23.5219 23.6577 23.7251 23.7977 23.902C23.9377 24.0788 24.1117 24.2258 24.3095 24.3343C24.5073 24.4427 24.7248 24.5105 24.9492 24.5334L26 24.6711C21.9715 28.4093 19.375 33.4371 18.659 38.886C17.9431 44.3349 19.1526 49.8627 22.0787 54.5148C25.0048 59.1668 29.4637 62.6508 34.6852 64.365C39.9068 66.0793 45.5631 65.9161 50.6771 63.9036C55.7911 61.8912 60.0418 58.1559 62.6948 53.3429C65.3478 48.53 66.2366 42.9416 65.2077 37.543C64.1788 32.1444 61.2967 27.2747 57.0594 23.775C52.822 20.2753 47.4954 18.3653 41.9997 18.375Z",
    fill: "url(#paint2_linear_1011_19255)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1011_19255",
    x1: 42,
    y1: 84,
    x2: 42,
    y2: -4.32905e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1011_19255",
    x1: 26.8115,
    y1: 42.2201,
    x2: 57.1865,
    y2: 42.2201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1011_19255",
    x1: 18.458,
    y1: 42.3001,
    x2: 65.6247,
    y2: 42.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShareHistory);
export default __webpack_public_path__ + "static/media/no-share-history.b8f345acb6ea78b9cc1dae4bdeff202c.svg";
export { ForwardRef as ReactComponent };